module.exports = "/_next/static/videos/softball-2-0284373440488ebf2a0d19c6fa063bbd.webm";